import React from 'react'

const Headling = ({ text }) => {
    return (
        <div className="main-header">
            <h1 className="mainTitle">{text}</h1>
        </div>
    )
}



export default Headling

